module.exports = __webpack_public_path__ + "img/xlsx.03999a06.png";